import { createAuthClient } from 'better-auth/client';
import { adminClient } from 'better-auth/client/plugins';
import { getBackendUrl } from './backendUrl';

export { getBackendUrl } from './backendUrl';

export const authClient = createAuthClient({
  // Better Auth needs an absolute base; a same-origin build ("") uses the page origin.
  baseURL: getBackendUrl() || window.location.origin,
  // Maps to the backend `/api/auth/*` routes mounted by Better Auth.
  basePath: '/api/auth',
  plugins: [adminClient()],
});

export type AuthUser = {
  id: string;
  email: string;
  name: string;
  // Tenant role, from GET /api/permissions.
  role: 'admin' | 'operator' | 'viewer';
  emailVerified: boolean;
  image?: string | null;
  /** undefined = not yet loaded; [] = loaded but empty (viewer). */
  permissions?: string[];
};

export type AuthSession = {
  token: string;
  expiresAt: Date | string;
};

export type AuthResponse = {
  user: AuthUser;
  session: AuthSession;
};

/** True if `userRole` ranks at or above `requiredRole`. */
export const hasPermission = (
  userRole: AuthUser['role'],
  requiredRole: AuthUser['role'],
): boolean => {
  const roleHierarchy: Record<AuthUser['role'], number> = {
    viewer: 0,
    operator: 1,
    admin: 2,
  };

  return (roleHierarchy[userRole] ?? 0) >= (roleHierarchy[requiredRole] ?? 0);
};

export const isAdmin = (user: AuthUser | null): boolean => {
  return user?.role === 'admin';
};
